/**
 * Sessão do painel admin — cookie httpOnly no servidor; marcador local só para rotas UI.
 */
import { fetchApi } from '@/api/http'

const KEY_ACTIVE = 'agendamentos-app:admin:active'
const KEY_ADMIN_EMAIL = 'agendamentos-app:admin:email'
const KEY_ADMIN_TENANT_SLUG = 'agendamentos-app:admin:tenant-slug'
const KEY_ADMIN_TENANT_NOME = 'agendamentos-app:admin:tenant-nome'
const LEGACY_TOKEN_KEY = 'agendamentos-app:admin:token'

function clearLegacyToken(): void {
  try {
    localStorage.removeItem(LEGACY_TOKEN_KEY)
  } catch {
    /* ignore */
  }
}

export function getAdminToken(): string | null {
  return null
}

export function getAdminEmail(): string | null {
  try {
    return localStorage.getItem(KEY_ADMIN_EMAIL)
  } catch {
    return null
  }
}

export function isAdmin(): boolean {
  try {
    clearLegacyToken()
    return sessionStorage.getItem(KEY_ACTIVE) === '1'
  } catch {
    return false
  }
}

export function isAdminClientPreviewMode(clientUser: unknown): boolean {
  return isAdmin() && !clientUser
}

export function getAdminTenantSlug(): string | null {
  try {
    return localStorage.getItem(KEY_ADMIN_TENANT_SLUG)
  } catch {
    return null
  }
}

export function getAdminTenantNome(): string | null {
  try {
    return localStorage.getItem(KEY_ADMIN_TENANT_NOME)
  } catch {
    return null
  }
}

export function setAdmin(
  _token: string | null,
  email: string,
  opts?: { tenantSlug?: string; tenantNome?: string }
): void {
  try {
    sessionStorage.setItem(KEY_ACTIVE, '1')
    localStorage.setItem(KEY_ADMIN_EMAIL, email)
    if (opts?.tenantSlug) localStorage.setItem(KEY_ADMIN_TENANT_SLUG, opts.tenantSlug)
    if (opts?.tenantNome) localStorage.setItem(KEY_ADMIN_TENANT_NOME, opts.tenantNome)
    clearLegacyToken()
  } catch {
    /* ignore */
  }
}

export function markAdminSessionActive(): void {
  try {
    sessionStorage.setItem(KEY_ACTIVE, '1')
    clearLegacyToken()
  } catch {
    /* ignore */
  }
}

export async function logoutAdminApi(): Promise<void> {
  try {
    await fetchApi('/api/admin/logout', { method: 'POST' })
  } catch {
    /* ignore */
  }
}

export function logoutAdmin(): void {
  const slug = getAdminTenantSlug()
  if (slug) {
    try {
      localStorage.setItem('agendamentos-app:tenant-slug', slug.trim().toLowerCase())
    } catch {
      /* ignore */
    }
  }
  try {
    sessionStorage.removeItem(KEY_ACTIVE)
    localStorage.removeItem(KEY_ADMIN_EMAIL)
    localStorage.removeItem(KEY_ADMIN_TENANT_SLUG)
    localStorage.removeItem(KEY_ADMIN_TENANT_NOME)
    clearLegacyToken()
  } catch {
    /* ignore */
  }
  void logoutAdminApi()
}
